import {
  createStyleSheet,
  flexMixin,
  GlobalThemeInterface,
  zIndexMixin,
  headerHeight,
  maxContainerWidth,
  vh,
} from '@groma-dev/blueprint';

export const getAppStyles = createStyleSheet(
  (theme: GlobalThemeInterface) => ({
    '@global': {
      body: {
        backgroundColor: theme.colors.$background100,
      },
    },
    mainContainer: {
      ...flexMixin('column', 'normal', 'center'),
      backgroundColor: theme.colors.$background100,
      height: '100%',
      maxWidth: '100%',
      minHeight: vh(),
      minWidth: '100%',
      width: '100%',
    },
    mainContent: {
      ...flexMixin(),
      height: '100%',
      maxWidth: `${maxContainerWidth}px`,
      minHeight: `calc(${vh()} - ${headerHeight}px)`,
      position: 'relative',
      scrollMarginTop: `${headerHeight}px`,
      width: '100%',
    },
    mobileAccountSelectContainer: {
      ...zIndexMixin(),
      width: '100%',
    },
    header: {
      borderBottom: `1px solid ${theme.colors.$primary300}`,
    },
    [`@media (max-width: ${theme.breakpoints.$md}px)`]: {
      mainContent: {
        ...flexMixin('column'),
      },
    },
  }),
  { name: 'App' }
);
